export enum SymbolTableGrid {
  FIVE_ROW_ITEMS_GRID = 'FIVE_ROW_ITEMS_GRID',
  FOUR_ROW_ITEMS_GRID = 'FOUR_ROW_ITEMS_GRID',
}
